
export default async function externalComponent(url:any) {
    const name = url.split(`/`).reverse()[0].match(/^(.*?)\.umd/)[1];


    if (window[name]) return window[name];

    return await new Promise((resolve, reject) => {
        const script = document.createElement(`script`);
        script.async = true;
        script.addEventListener(`load`, () => {
              return resolve(window[name]);
        });
        script.addEventListener(`error`, () => {
            return reject(new Error(`Error loading ${url}`));
        });
        script.src = url;
        document.head.appendChild(script);
    });
}

